import React from "react";
import { StyleSheet, Text, TouchableOpacity, View, Image } from "react-native";
import { colors } from "src/assets";
import { IRequest } from "src/domains";
import { stringDateFullDynamicFormat } from "src/utils/date";
import { checkReviewExpected } from "src/utils/call";
import { Icon } from "src/components";
import { UserStatus } from "src/domains";
import { trim } from "src/utils/string";
import LocalText from "src/local";

type iconProps = {
  color: string;
};

const OutgoingCallIcon = ({ color }: iconProps) => {
  return (
    <svg width="18.064" height="18.049" viewBox="0 0 18.064 18.049">
      <path
        d="M3.9,15.061l-.021.015-.45-.455-.043-.042L2.906,14.1l.022-.02C-.363,10.3-1.394,4.334,2.547.393L2.713.227,5.213,0,8.677,3.464l-.219,2.4-.066.119A3.716,3.716,0,0,1,6.073,7.441,4.13,4.13,0,0,0,7.5,10.568a4.247,4.247,0,0,0,2.955,1.426c.059,0,.114,0,.163-.005a3.714,3.714,0,0,1,1.454-2.317L12.2,9.6l2.4-.218,3.465,3.465-.227,2.5-.166.166a8.58,8.58,0,0,1-6.2,2.533A11.719,11.719,0,0,1,3.9,15.061ZM3.3,1.474c-3.351,3.554-2.149,8.956,1,12.193l.057.058.033.032a10.439,10.439,0,0,0,7.073,3,7.314,7.314,0,0,0,5.12-1.993l.129-1.423-2.606-2.606-1.47.134a3.743,3.743,0,0,0-.869,1.843l-.085.354-.346.112a2.983,2.983,0,0,1-.882.114,5.511,5.511,0,0,1-3.872-1.806c-2.413-2.457-1.73-4.67-1.7-4.762L5,6.375l.354-.085A3.74,3.74,0,0,0,7.2,5.422l.134-1.471L4.725,1.345ZM10.916,6.99a.648.648,0,0,1,0-.916l4.079-4.079L13.987.987,17.282.638l-.341,3.3-1.03-1.03L11.832,6.99a.647.647,0,0,1-.916,0Z"
        fill={color}
      />
    </svg>
  );
};

const CanceledCallIcon = ({ color }: iconProps) => {
  return (
    <svg width="18.064" height="18.049" viewBox="0 0 18.064 18.049">
      <path
        d="M3.9,15.061l-.021.015-.45-.455-.043-.042L2.906,14.1l.022-.021C-.363,10.3-1.394,4.334,2.547.393L2.713.227,5.213,0,8.677,3.464l-.219,2.4-.066.12A3.716,3.716,0,0,1,6.073,7.441,4.13,4.13,0,0,0,7.5,10.568a4.247,4.247,0,0,0,2.955,1.426c.059,0,.114,0,.163-.005a3.716,3.716,0,0,1,1.454-2.317L12.2,9.6l2.4-.218,3.465,3.465-.227,2.5-.166.166a8.58,8.58,0,0,1-6.2,2.533A11.719,11.719,0,0,1,3.9,15.061ZM3.3,1.475c-3.351,3.553-2.149,8.956,1,12.193l.057.058.033.032a10.439,10.439,0,0,0,7.073,3,7.316,7.316,0,0,0,5.12-1.993l.129-1.423-2.606-2.606-1.47.133a3.743,3.743,0,0,0-.869,1.843l-.085.354-.346.112a2.982,2.982,0,0,1-.882.114,5.51,5.51,0,0,1-3.872-1.805c-2.413-2.457-1.73-4.67-1.7-4.763L5,6.376l.354-.085A3.74,3.74,0,0,0,7.2,5.422l.134-1.471L4.725,1.345ZM16.278,6.488l-2-2-2,2a.648.648,0,0,1-.916-.916l2-2-2-2A.648.648,0,0,1,12.27.647l2,2,2-2a.648.648,0,1,1,.916.916l-2,2,2,2a.648.648,0,1,1-.916.916Z"
        transform="translate(0 0)"
        fill={color}
      />
    </svg>
  );
};

const ActiveCallIcon = ({ color }: iconProps) => {
  return (
    <svg width="21.651" height="22" viewBox="0 0 21.651 22">
      <path
        d="M4.067,19.1l-.031.031L2.861,17.946l.027-.024C-.383,14.1-1.38,8.125,2.577,4.168l.191-.191,2.581-.234L8.88,7.273l-.225,2.47-.077.137a3.764,3.764,0,0,1-2.312,1.482,4.105,4.105,0,0,0,1.409,2.986,4.153,4.153,0,0,0,2.888,1.4h.09a3.763,3.763,0,0,1,1.481-2.309l.138-.076,2.469-.225,3.531,3.531-.235,2.581-.191.191A8.682,8.682,0,0,1,11.573,22,11.806,11.806,0,0,1,4.067,19.1ZM3.447,5.412C.166,8.926,1.362,14.253,4.475,17.451l.052.054.036.035a10.346,10.346,0,0,0,7.01,2.969A7.223,7.223,0,0,0,16.6,18.567l.122-1.341-2.543-2.543-1.391.126a3.763,3.763,0,0,0-.819,1.773l-.1.407-.4.13a3.113,3.113,0,0,1-.913.119A5.61,5.61,0,0,1,6.621,15.4c-2.456-2.5-1.756-4.77-1.725-4.865l.13-.4.407-.1a3.757,3.757,0,0,0,1.773-.819l.127-1.391L4.789,5.29ZM20.16,10.789a9.579,9.579,0,0,0-9.563-9.3c-.046,0-.09,0-.135,0V0c.046,0,.09,0,.135,0A11.071,11.071,0,0,1,21.651,10.789Zm-3.529,0A6.048,6.048,0,0,0,10.6,5.02c-.046,0-.09,0-.135,0V3.532c.045,0,.09,0,.135,0a7.539,7.539,0,0,1,7.525,7.26Z"
        transform="translate(0 0)"
        fill={color}
      />
    </svg>
  );
};

const ChevronIcon = ({ color }: iconProps) => {
  return (
    <svg width="5.972" height="10" viewBox="0 0 5.972 10">
      <path
        d="M673.227,1210.877a.887.887,0,0,1,.629.26l4.193,4.193a.889.889,0,0,1,0,1.258l-4.028,4.028a.889.889,0,1,1-1.258-1.257l3.4-3.4-3.564-3.564a.889.889,0,0,1,.629-1.518Z"
        transform="translate(-672.338 -1210.877)"
        fill={color}
      />
    </svg>
  );
};

export type CallHistoryItemProps = {
  cognitoUserId: string;
  item: IRequest;
  color: "white" | "transparent";
  onPress?: () => void;
};

enum CallIcon {
  None,
  Outgoing,
  Canceled,
  Active,
}

enum CallState {
  Unknown,
  Active,
  Incoming,
  Outgoing,
  Canceled,
}

export const CallHistoryItem: React.FC<CallHistoryItemProps> = ({
  color,
  cognitoUserId,
  item,
  onPress,
}) => {
  let avatarStyle = {};
  let containerStyle = {};
  let offerStyle = {};
  let userName: string = "";
  let userImageUrl: string | undefined;
  let backgroundColor: string = color;
  if (item.sender?.id === cognitoUserId) {
    userName = item.opponent?.name || "Unknown";
    userImageUrl = item.opponent?.image;
    avatarStyle = {
      ...(item.opponent?.status === UserStatus.LOGOUT
        ? {
            borderColor: colors.chokuGray6,
          }
        : {}),
      ...(item.opponent?.status === UserStatus.OFFERABLE
        ? {
            borderColor: colors.chokuGreen,
          }
        : {}),
      ...(item.opponent?.status === UserStatus.ACTIVE
        ? {
            borderColor: colors.orange,
          }
        : {}),
      ...(item.opponent?.status === UserStatus.IN_CALL
        ? {
            borderColor: colors.chokuRed,
          }
        : {}),
    };
  } else {
    userName = item.sender?.name || "Unknown";
    userImageUrl = item.sender?.image;
    avatarStyle = {
      ...(item.sender?.status === UserStatus.LOGOUT
        ? {
            borderColor: colors.chokuGray6,
          }
        : {}),
      ...(item.sender?.status === UserStatus.OFFERABLE
        ? {
            borderColor: colors.chokuGreen,
          }
        : {}),
      ...(item.sender?.status === UserStatus.ACTIVE
        ? {
            borderColor: colors.orange,
          }
        : {}),
      ...(item.sender?.status === UserStatus.IN_CALL
        ? {
            borderColor: colors.chokuRed,
          }
        : {}),
    };
  }

  let callState: CallState = CallState.Unknown;
  let callIcon: CallIcon = CallIcon.None;
  let callIconColor: string = "#C9C9C9";

  if (["WAITING_OPPONENT"].indexOf(item.status) !== -1) {
    callState = CallState.Active;
  } else if (
    [
      "CANCELED_BY_SENDER",
      "REJECTED_BY_OPPONENT",
      "CALL_REJECTED",
      "EXPIRED",
    ].indexOf(item.status) !== -1
  ) {
    callState = CallState.Canceled;
  } else if (item.senderId === cognitoUserId) {
    callState = CallState.Outgoing;
  } else if (item.opponentId === cognitoUserId) {
    callState = CallState.Incoming;
  }

  if (callState === CallState.Active) {
    callIcon = CallIcon.Active;
    callIconColor = "#0ADFDD";
    backgroundColor = "#C2FCFA";
  } else if (callState === CallState.Canceled) {
    callIcon = CallIcon.Canceled;
    callIconColor = colors.chokuRed;
    offerStyle = { ...offerStyle, color: colors.chokuRed };
  } else if (callState === CallState.Outgoing) {
    callIcon = CallIcon.Outgoing;
  }

  containerStyle = { ...containerStyle, backgroundColor };

  return (
    <TouchableOpacity
      style={[styles.container, containerStyle]}
      onPress={onPress}
    >
      {callState === CallState.Active ? (
        <View style={styles.activeContainer}>
          <Text style={styles.activeText}>
            {LocalText.screens.callHistoryList.callHistoryItem.activeCall}
          </Text>
        </View>
      ) : null}
      <View style={styles.content}>
        <View style={styles.contentCol1}>
          {callIcon === CallIcon.Active ? (
            <ActiveCallIcon color={callIconColor} />
          ) : null}
          {callIcon === CallIcon.Canceled ? (
            <CanceledCallIcon color={callIconColor} />
          ) : null}
          {callIcon === CallIcon.Outgoing ? (
            <OutgoingCallIcon color={callIconColor} />
          ) : null}
        </View>
        <View style={styles.contentCol2}>
          <Text style={[styles.offer, offerStyle]}>
            {trim(item.service?.title || "", 32, "...")}
          </Text>
          <View style={styles.userContainer}>
            {userImageUrl ? (
              <Image
                style={[styles.avatar, avatarStyle]}
                source={{ uri: userImageUrl }}
              />
            ) : (
              <View style={[styles.avatar, styles.avatarEmpty, avatarStyle]}>
                <Icon name={"person"} color={colors.chokuGray5} size={10} />
              </View>
            )}

            <Text style={styles.username}>
              {trim(userName || "", 32, "...")}
              さん
            </Text>
          </View>
        </View>
        <View style={styles.timeContainer}>
          {checkReviewExpected(item, cognitoUserId) ? (
            <Text style={styles.review}>
              {
                LocalText.screens.callHistoryList.callHistoryItem
                  .waitingForReview
              }
            </Text>
          ) : null}
          <Text style={styles.time}>
            {stringDateFullDynamicFormat(item.createdAt)}
          </Text>
        </View>
        <View style={styles.chevron}>
          <ChevronIcon color={"#a5a5a5"} />
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
  },
  containerWhite: {
    backgroundColor: colors.white,
  },
  content: {
    flexDirection: "row",
  },
  contentCol1: {
    width: 48,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  contentCol2: {
    flex: 1,
    paddingVertical: 16,
  },
  userContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: 10,
  },
  avatar: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: colors.gray1,
  },
  avatarEmpty: {
    backgroundColor: colors.gray1,
    justifyContent: "center",
    alignItems: "center",
  },
  username: {
    fontSize: 12,
    color: colors.chokuGray5,
    marginLeft: 8,
  },
  offer: {
    fontSize: 14,
    fontWeight: "500",
    color: colors.chokuBlack,
    lineHeight: 22,
  },
  timeContainer: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 16,
  },
  time: {
    fontSize: 12,
    fontWeight: "500",
    color: colors.chokuGray5,
  },
  review: {
    fontSize: 12,
    fontWeight: "500",
    color: colors.chokuBlack,
    paddingBottom: 4,
  },
  chevron: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: 30,
  },
  activeContainer: {
    backgroundColor: "#00E5E1",
  },
  activeText: {
    paddingLeft: 8,
    paddingVertical: 4,
    fontSize: 12,
    fontWeight: "500",
    color: colors.white,
  },
});
